<template>
  <app-content class="h-panel">
    <Loading text="数据加载中..." :loading="loading"></Loading>
    <div class="h-panel-bar">
      <span class="h-panel-title">利润表月报</span>
    <div class="float-right">
      <Button size="s" icon="fa fa-print" @click="printReport">打印</Button>
      <DropdownMenu button @click="ioTrigger" :datas="ioMenus" size="s">导出</DropdownMenu>
    </div>
    </div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <account-date-choose v-model="accountDate"/>
      </Cell>
      <Cell class="label">核算组织：</Cell>
      <Cell>
        <TreePicker :option="orgOption"  style="display: inline-block;min-width: 150px"
                    ref="orgTreePicker" v-model="orgId"></TreePicker>
      </Cell>
      <Cell>
        <Button :disabled="!report" :loading="loading" color="primary" @click="doSearch">查询</Button>
      </Cell>
    </Row>
    <div class="h-panel-body" v-if="report">
      <Table class="small-td" :datas="templateItems" selectRow border>
        <TableItem title="名称">
          <div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">
            {{ data.title }}
          </div>
        </TableItem>
        <TableItem title="行次">
          <template slot-scope="{data}">
            {{ data.isClassified ? '' : data.lineNum > -1 ? data.lineNum : '' }}
          </template>
        </TableItem>
        <TableItem title="本年累计金额" align="right">
          <template slot-scope="{data}">
            {{ reportData[data.id] ? reportData[data.id].currentYearAmount : '' | numFormat }}
          </template>
        </TableItem>
        <TableItem title="本期金额" align="right">
          <template slot-scope="{data}">
            {{ reportData[data.id] ? reportData[data.id].currentPeriodAmount : '' | numFormat }}
          </template>
        </TableItem>
      </Table>
    </div>
    <Modal v-model="batchModal" title="批量导出" :width="520">
    <div class="padding">
      <p class="dark2-color">每期导出为一个工作表，单次最多导出 36 期。</p>
      <Row type="flex" :space-x="10" class="margin-top" :align="'middle'">
        <Cell class="label">开始期间</Cell>
        <Cell><account-date-choose v-model="batchStart"/></Cell>
        <Cell class="label">结束期间</Cell>
        <Cell><account-date-choose v-model="batchEnd"/></Cell>
      </Row>
    </div>
    <div slot="footer">
      <Button @click="batchModal=false">取消导出</Button>
      <Button color="primary" :loading="batchLoading" @click="doExportBatch">开始导出</Button>
    </div>
  </Modal>
</app-content>
</template>

<script>
  import reportIoMixin from '../../js/common/report-io-mixin';
import {mapState} from 'vuex'

export default {
  name: "ProfitStatement",
  mixins: [reportIoMixin],
  data() {
    return {
      orgOption: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'title',
        dataMode: 'list',
        datas: []
      },
      report: null,
      reportData: {},
      accountDate: null,
      dataList: [],
      orgId: null,
      org: null,
      loading: false
    }
  },
  computed: {
    ...mapState(['User', 'orgDatas', 'currentOrgId']),
    templateItems() {
      return this.report ? this.report.items : [];
    }
  },
  methods: {
    doSearch() {
      this.loadReport();
    },
    loadReport() {
      Api.report.template.list().then(({data}) => {
        const tpl = data.find(t => t.templateKey === 'lrb');
        if (!tpl) {
          this.loading = false;
          this.$Message.success('未授权利润表模板~');
          return;
        }
        Api.report.template.load(tpl.id).then(({data: rpt}) => {
          this.report = rpt;
          this.$nextTick(this.loadReportData);
        });
      });
    },
    loadReportData() {
      if (this.accountDate) {
        this.loading = true;
        Api.report.view(this.report.id, {accountDate: this.accountDate, orgId: this.orgId, dimension: 'MONTH'}).then(({data}) => {
          this.reportData = data;
        }).finally(() => this.loading = false);
      } else {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.currentOrgId) {
      this.orgId = this.currentOrgId;
    }
    if (this.orgDatas && this.orgDatas.length) {
      this.orgOption.datas = this.orgDatas.map(val => {
        return {id: val.id, name:val.name, type: val.type, title: `[${val.code}]${val.name}`, parentId: val.parentId,currentAccountDate:val.currentAccountDate,enableDate:val.enableDate}
      });
    } else {
      this.$watch('orgDatas', () => {
        if (this.orgDatas && this.orgDatas.length && !this.orgOption.datas.length) {
          this.orgOption.datas = this.orgDatas.map(val => ({id: val.id, name:val.name, type: val.type, title: `[${val.code}]${val.name}`, parentId: val.parentId,currentAccountDate:val.currentAccountDate,enableDate:val.enableDate}));
        }
      }, { immediate: true });
    }
    this.$nextTick(() => {
      this.$refs.orgTreePicker.expandAll();
    });
    this.loadReport();
  }
}
</script>

<style scoped>
div.font-bold {
  font-size: 14px;
}
</style>